<template>
<div id='Msg'>

	<div :class="{'msg-model':true, 'msg-model-show':msg_show===1}">
		<img class='msg-model-icon' :src='status' />
		<div class='msg-model-btn' @click='vMsg_close'>
			<img class='msg-model-btn-icon' src='@/assets/icon/msg-close.png' />
		</div>
		<div class='msg-model-title font-16'>{{title}}</div>
		<div class='msg-model-content font-14'>{{content}}</div>
	</div>

</div>
</template>
<script>
import iconInformation from '@/assets/icon/msg-information.png';
import iconSuccess from '@/assets/icon/msg-success.png';
import iconFail from '@/assets/icon/msg-fail.png';
import iconWarning from '@/assets/icon/msg-warning.png';

export default {
	name: 'Msg',
	props: {},
	data() {
		return {
			msg_show: 0,
			statusMap: {
				information: {
					icon: iconInformation,
					title: '提示'
				},
				success: {
					icon: iconSuccess,
					title: '成功'
				},
				fail: {
					icon: iconFail,
					title: '失败'
				},
				warning: {
					icon: iconWarning,
					title: '警告'
				},
			},
			status: '',
			title: '',
			content: '',
			timer: 4500,
			timerId: false,
		}
	},
	methods: {
		// show方法
		vMsg_Change(status, title, content, timer) {
			if (this.msg_show !== 0) return;

			if (status.constructor['name'] === 'String') {
				this.status = this.statusMap[status].icon;
				// this.title = this.statusMap[status].title;
			}
			if (title.constructor['name'] === 'String')   this.title=title;
			if (content.constructor['name'] === 'String') this.content=content;
			if (timer && timer.constructor['name'] === 'Number') this.timer=timer;

			this.msg_show = 1;

			this.timerId = setTimeout(() => {
				this.vMsg_close();
			}, this.timer);
		},
		// close方法
		vMsg_close() {
			if (this.msg_show === 1) {
				clearTimeout(this.timerId);
				this.msg_show = 2;
				setTimeout(() => {
					this.status = '';
					this.title = '';
					this.content = '';
					this.msg_show = 0;
				}, 300);
			}
		},
	}
}
</script>
<style scoped>
#Msg{
}
.msg-model {
	background:rgba(255, 255, 255, 1);
	width:335px; min-height:60px;
	display:flex; flex-direction:column; align-items:flex-end;
	box-sizing:border-box; padding:18px 16px 10px 0;
	border-radius:4px;
	opacity:0;
	box-shadow:0 1px 6px rgba(0, 0, 0, .2);
	position:fixed; top:80px; right:-340px;
	transition: all 0.3s ease-in-out 0s;
	z-index:400;
}
.msg-model-show {
	opacity:1;
	transform: translateX(-360px);
}
.msg-model-icon {
	width:30px; height:30px;
	position:absolute; top:16px; left:20px;
}
.msg-model-btn {
	width:22px; height:22px;
	display:flex; justify-content:center; align-items:center;
	overflow:hidden;
	position:absolute; top:11px; right:8px;
	cursor:pointer;
	transition: all 0.2s ease-in-out 0s;
}
.msg-model-btn:hover {
	box-shadow:0 0 6px rgba(0, 0, 0, .1);
}
.msg-model-btn-icon {
	width:14px; height:14px;
}
.msg-model-title {
	width:250px; color:#17233d; letter-spacing:1px;
	box-sizing:border-box; padding-right:20px;
}
.msg-model-content {
	width:250px; color:#515a6e; margin:8px 0 0 0;
}
</style>




// WEBPACK FOOTER //
// src/components/popup/Msg.vue